module.exports = __webpack_public_path__ + "hyperion-v2-static/img/SeeristEssentials.36015863.png";